


























import { Component, Prop, Vue, Watch, Emit } from 'vue-property-decorator'

@Component
export default class Topic extends Vue {
    @Prop(Number)
    private index!: number;
    @Prop()
    private topic: any;
    @Prop(Boolean)
    private autoShow!: boolean;
    @Prop(Boolean)
    private showInfo!: boolean;

    private disable = false;
    private showAnswer = false;
    private myAnswer: string = "";
    private myAnswers: string[] = [];

    @Watch('topic')
    watchData(newVal: any, oldVal: any) {
        this.myAnswer = "";
        this.myAnswers = [];
        this.showAnswer = false;
    }

    private onChange(value: any) {
        if (this.topic.topicType == 2) {
            this.myAnswers = value.sort();
            this.myAnswer = this.myAnswers.join('');
            if (this.autoShow && this.topic.answer == this.myAnswer) {
                this.showAnswer = true;
            }
        } else {
            this.myAnswer = value;
            if (this.autoShow) {
                this.showAnswer = true;
            }
        }
        console.log(this.topic);
        this.$emit("answer", this.index, this.myAnswer);
    }

    public setMyAnswer(value: any) {
        if (this.topic.topicType == 2) {
            this.myAnswers = value.split("");
            this.myAnswer = value;
        } else {
            this.myAnswer = value;
        }
    }

    public show(readonly = false): boolean {
        this.showAnswer = true;
        this.disable = readonly;
        return this.myAnswer == this.topic.answer;
    }
}
